import PropTypes from 'prop-types';
import React from 'react';
import FaLaptop from 'react-icons/lib/fa/laptop';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { getThumbnailUrl } from '~services/utils'; // eslint-disable-line

import Button from '../../components/Button'

import messages from './messages/PortFolioBadge_messages';
// import './styles/PortFolioBadge.scss';

const PortfolioBadge = ({ identifier, portfolio: { slides = [] } }) => (
  <Badge>
    <Slides>
      {slides
        .filter(slide => !!slide.image_id)
        .slice(0, 4)
        .map(({ image_id: imageId }) => (
          <Slide imageUrl={getThumbnailUrl(imageId)} key={`img_${imageId}`} />
        ))}
    </Slides>
    <ButtonWrap>
      <Button
        as="a"
        badge
        href={`/selvitys/esite/FI/${identifier}`}
        rel="noopener noreferrer"
        target="_blank"
        type="success"
      >
        <FormattedMessage
          {...messages.callToActionButton}
          info="Check out brochure"
        />
        <ButtonIcon />
      </Button>
    </ButtonWrap>
  </Badge>
);

PortfolioBadge.propTypes = {
  identifier: PropTypes.string.isRequired,
  portfolio: PropTypes.object.isRequired,
};

const Badge = styled.div`
  position: relative;
`;

const ButtonIcon = styled(FaLaptop)`
  font-size: 20pt;
  margin-left: 6px;
`;

const ButtonWrap = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  align-items: center;
  padding-right: 32px;
`;

const Slide = styled.div`
  background-image: ${props => props.imageUrl};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  flex: 1;
  height: 200px;
`;

const Slides = styled.div`
  border-radius: 6px;
  box-shadow: 0px 1px 25px 3px ${props => props.theme['grey-normal']};
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;

  &:after {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export default PortfolioBadge;
